
  import { Options, Vue } from 'vue-class-component';   
  import Common from '@/services/common.js';  
  import App from './App.vue';  
  import $ from 'jquery';  
  import 'bootstrap'; 
  import Basic from '@/components/Basic.vue';  


  // import useVuelidate from '@vuelidate/core';
  // import { required, minLength, email, sameAs,between } from '@vuelidate/validators';

  import Axios from "axios";
  @Options({
    components: {  
      Basic
    }, 
  })

  export default class Terms extends Vue { 
    terms ={}; 
    STORAGE_KEY = "caprock-local";   
    data () {    
      Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';  
      this.get_termss(); 
       
      return {
        terms:this.terms  
      }
    }   
  
    get_termss(){ 
      Common.get_terms()
      .then(response => { 
        if(typeof response.data!== 'undefined' && response.data.success==200){ 
          console.log()
          $('#htmld').html(response.data.terms);
        }
      }).catch(e => {
          console.log(e)
      });
    } 
    created() {      
      document.title = 'Terms of Use || Caprock Merchant Platform';  
    }
     
     
  } 
